define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"Specification/BOM/BOMSupplierAttributesMixin"
], function(declare,Copy,BOMSupplierAttributesMixin) {

	return declare([Copy, BOMSupplierAttributesMixin], {});
});